import { http } from "../../utils/config";

const permissionAPI = {
  getListAllPermission: (params = {}) => {
        const {
            search = "",
        } = params;

        const queryParams = new URLSearchParams({
            ...(search && { search }),
        });

    return http.get(`/api/v1/security/permissions/get-list-all-permission?${queryParams}`);
  },

  // Get by ID
  getPermissionById: (id) => {
    return http.get(`/api/v1/security/permissions/${id}`);
  },

  // Create new 
  createPermission: (permissionData) => {
    return http.post('/api/v1/security/permissions', permissionData);
  },

  // Delete
  deletePermission: (id) => {
    return http.delete(`/api/v1/security/permissions/${id}`);
  },

  // Update
  updatePermission: (id, permissionData) => {
    return http.put(`/api/v1/security/permissions/${id}`, permissionData);
  },

  // Get by user ID
  getPermissionByUserId: (id) => {
    return http.get(`/api/v1/security/user/permissions/${id}`);
  },

  assignToUser: (permissionData) => {
    return http.post('/api/v1/security/permissions/assign-to-user', permissionData);
  },

  permissionParent: () => {
    return http.get(`/api/v1/security/permissions/permission-parent`);
  },
};

// Helper functions for handling API responses
export const permissionHelpers = {
  // Extract  data from API response
  extractPermissionData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Extract paginated list from API response
  extractPermissionList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        permissions: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
          nextPageUrl: data.next_page_url,
          prevPageUrl: data.prev_page_url
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Format data for form submission
  formatPermissionData: (formData) => {
    return {
      name: formData.name?.trim(),
      label: formData.label?.trim(),
      //   status: formData.status ?? true,
      parent_id: formData.parent_id || null,
    };
  },

  // Validate data before submission
  validatePermissionData: (permissionData) => {
    const errors = {};

    if (!permissionData.name?.trim()) {
      errors.name = 'Tên quyền không được để trống';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      
      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401:
            throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403:
            throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404:
            throw new Error('Không tìm thấy khách hàng');
          case 422:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        // Network error
        throw new Error('Không thể kết nối đến server');
      } else {
        // Other error
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

// Wrapped API functions with error handling
export const permissionAPIWithErrorHandling = {
  getListAllPermission: withErrorHandling(permissionAPI.getListAllPermission),
  getAssetById: withErrorHandling(permissionAPI.getAssetById),
  createPermission: withErrorHandling(permissionAPI.createPermission),
  deletePermission: withErrorHandling(permissionAPI.deletePermission),
  updatePermission: withErrorHandling(permissionAPI.updatePermission),
  getPermissionByUserId: withErrorHandling(permissionAPI.getPermissionByUserId),
  assignToUser: withErrorHandling(permissionAPI.assignToUser),
  permissionParent: withErrorHandling(permissionAPI.permissionParent),
};

export default permissionAPI;